import { Gauge } from "lucide-react";
import { Notify } from "@/components/ui/notify";
import { useMachineOee } from "@/features/oee/hooks";
import { MachineMetric } from "@/features/oee/MachineMetric";
import { useLineTrackedByMachine } from "@/hooks/useLineTrackedByMachine";

interface Props {
  machineId: string;
  lineId: string;
}

// Disponibilidade + Qualidade + refugo acumulado DESTA máquina, na tela da
// máquina. Só aparece em linha rastreada por máquina (predicado canônico useLineTrackedByMachine).
// Qualidade só p/ máquina-contador (produzido); Disponibilidade vale p/ qualquer máquina. SEM OEE composto.
export function MachineIndicatorsBlock({ machineId, lineId }: Props) {
  const trackedByMachine = useLineTrackedByMachine(lineId);
  const oeeQuery = useMachineOee(lineId, "24h", { enabled: trackedByMachine });
  const { data } = oeeQuery;
  const item = data?.items.find((i) => i.machineId === machineId);
  if (!trackedByMachine) return null;

  if (oeeQuery.isError) {
    return (
      <section className="space-y-2 rounded-md border p-3">
        <h3 className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-muted-foreground">
          <Gauge className="h-3.5 w-3.5" />
          Indicadores da máquina
        </h3>
        <Notify.QueryError
          error={oeeQuery.error}
          onRetry={() => void oeeQuery.refetch()}
          variant="inline"
        />
      </section>
    );
  }

  if (!item) return null;

  return (
    <section className="space-y-2 rounded-md border p-3">
      <h3 className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-muted-foreground">
        <Gauge className="h-3.5 w-3.5" />
        Indicadores da máquina
      </h3>
      <div className="space-y-1.5">
        <MachineMetric label="Disponibilidade" value={item.availability} nullLabel="—" />
        {item.isProductionCounter ? (
          <>
            <MachineMetric label="Qualidade" value={item.quality} nullLabel="Insuficiente" />
            <dl className="grid grid-cols-3 gap-2 rounded bg-muted/20 p-2 text-[11px]">
              <div>
                <dt className="text-muted-foreground">Refugo</dt>
                <dd className="font-mono font-semibold">{item.scrapReject}</dd>
              </div>
              <div>
                <dt className="text-muted-foreground">Desperdício</dt>
                <dd className="font-mono font-semibold">{item.scrapWaste}</dd>
              </div>
              <div>
                <dt className="text-muted-foreground">Retrabalho</dt>
                <dd className="font-mono font-semibold">{item.scrapRework}</dd>
              </div>
            </dl>
            <p className="text-[10px] text-muted-foreground">
              Produzido {item.producedQty} · bom {item.goodQty}
            </p>
          </>
        ) : null}
      </div>
    </section>
  );
}
